// 📄 components/proyecto/CollapsedStatsBar.tsx
// Barra resumen de una línea que reemplaza al ProjectStatsPanel completo
// cuando está comprimido. Usa los mismos datos de useProjectStats — ver
// ProjectStatsPanel.tsx, que llama al hook una sola vez y se lo pasa tanto
// a esta barra como a GeneralStatsView.
import React from 'react';
import { BarChart3, ChevronDown } from 'lucide-react';
import { ProjectStats } from '../../hooks/useProjectStats.ts';

interface CollapsedStatsBarProps {
  stats: ProjectStats;
  onExpand: () => void;
}

export default function CollapsedStatsBar({ stats, onExpand }: CollapsedStatsBarProps) {
  const { loading, error, porcentaje, pasosCompletados, totalPasos, srCount, issuesAbiertosCount, interfacesCount } = stats;

  return (
    <button
      onClick={onExpand}
      aria-expanded={false}
      aria-label="Expandir panel de estadísticas del proyecto"
      title="Expandir panel"
      className="w-full flex items-center justify-between gap-3 px-4 py-3 bg-white/5 hover:bg-white/10 border border-white/10 rounded-2xl transition-colors text-left"
    >
      <div className="flex items-center gap-3 text-sm text-gray-300 flex-wrap min-w-0">
        <span className="flex items-center gap-1.5 text-gray-400 flex-shrink-0">
          <BarChart3 className="w-4 h-4" />
          <span className="font-medium text-gray-300">Estadísticas</span>
        </span>

        {loading ? (
          <span className="h-4 w-48 bg-white/10 rounded animate-pulse" />
        ) : error ? (
          <span className="text-gray-500">No se pudieron cargar las estadísticas.</span>
        ) : (
          <>
            <Separator />
            <span>Progreso: {porcentaje}% ({pasosCompletados}/{totalPasos})</span>
            <Separator />
            <span>SR: {srCount}</span>
            <Separator />
            <span className={issuesAbiertosCount > 0 ? 'text-amber-400' : ''}>Issues: {issuesAbiertosCount}</span>
            <Separator />
            <span>Interfaces: {interfacesCount}</span>
          </>
        )}
      </div>

      <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" />
    </button>
  );
}

function Separator() {
  return <span className="text-gray-600" aria-hidden="true">·</span>;
}
